import React from 'react';
import './typography.css';
import Iubenda from './components/Iubenda';
// import LanguageSelector from './components/LanguageSelector';
import NewLanding from './components/NewLanding/NewLanding';

const App: React.FC = () => {
  return (
    <div style={{ background: '#08090a', minHeight: '100vh', width: '100%', overflowX: 'hidden' }}>
      <Iubenda />
      <NewLanding />
      {/* <LanguageSelector /> */}
    </div>
  );
};

export default App;
